import { defineComponent as P, provide as x, ref as d, computed as p, watch as c, onMounted as B, openBlock as n, createElementBlock as r, normalizeClass as f, createElementVNode as V, Fragment as S, renderList as T, createBlock as v, unref as N, createCommentVNode as C, createTextVNode as U, toDisplayString as w } from "vue";
import { EPinInputVariant as E, PinInputSymbol as z, getPinInputContainerStyleClasses as M, getPinInputStyleClasses as $ } from "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import j from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
import A from "./novoui-vuejs820.js";
const F = { class: "pin-input-wrapper" }, L = /* @__PURE__ */ V("span", { class: "input-label" }, null, -1), q = {
  key: 0,
  class: "input-assistive"
}, Bt = /* @__PURE__ */ P({
  __name: "NPinInput",
  props: {
    variant: { default: E.outline },
    assistiveText: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    pinInputCount: { default: 4 },
    modelValue: { default: void 0 }
  },
  emits: [
    /**
     * Event emitted when the model value changes
     */
    "update:modelValue",
    /**
     * Event emitted when the pin input is completed
     */
    "completed"
  ],
  setup(I, { emit: _ }) {
    const t = I;
    x(z, {
      variant: t.variant,
      disabled: t.disabled,
      pinInputCount: t.pinInputCount,
      invalid: t.invalid
    });
    const o = d(Array(t.pinInputCount).fill("")), g = p(() => o.value.join(""));
    c(g, (e, i) => {
      m("update:modelValue", e), i.length !== t.pinInputCount && e.length === t.pinInputCount && m("completed", e);
    }), c(t.modelValue, () => {
      t.modelValue && s();
    }), B(() => {
      t.modelValue && s();
    });
    const s = () => {
      o.value = t.modelValue.split("").map((e) => e);
    }, m = _, y = p(() => M(t)), b = p(() => $(t)), l = d(-1);
    function k(e, i) {
      i ? l.value = e + 1 : l.value = e;
    }
    const D = (e) => {
      e.preventDefault();
      const i = e.clipboardData;
      if (i) {
        const u = i.getData("text");
        o.value = u.split("").map((a) => a);
      }
    };
    return (e, i) => (n(), r("div", {
      class: f(["input", y.value])
    }, [
      V("div", F, [
        (n(!0), r(S, null, T(o.value, (u, a) => (n(), v(A, {
          "onUpdate:singleDigit": k,
          onPaste: D,
          class: f(b.value),
          focusedIndex: l.value,
          key: a,
          keyindex: a,
          disabled: t.disabled,
          modelValue: o.value[a],
          "onUpdate:modelValue": (h) => o.value[a] = h,
          modelModifiers: { trim: !0 }
        }, null, 8, ["class", "focusedIndex", "keyindex", "disabled", "modelValue", "onUpdate:modelValue"]))), 128))
      ]),
      L,
      e.assistiveText ? (n(), r("div", q, [
        t.invalid ? (n(), v(N(j), {
          key: 0,
          icon: "warning",
          size: 12
        })) : C("", !0),
        U(" " + w(e.assistiveText), 1)
      ])) : C("", !0)
    ], 2));
  }
});
export {
  Bt as default
};
